<template>
    <div>
        <div class="modal fade" id="richTextModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">Text Editor</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div id="richTextEditorForm">
                            <vue3-trix-editor input-id="richTextEditorFormInModal" :model-object="component" text-field="value"></vue3-trix-editor>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">Ok</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue3TrixEditor from "../../components/Vue3TrixEditor.vue";

    export default {
        name: 'RichTextModal',
        props: {
            yesEvent: Function,
            component: Object
        },
        components: {
            Vue3TrixEditor
        },
        data () {
            return {
                model: webase.model,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('richTextModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)

            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)

            this.currentModal.show()
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {
                // call the parent's "yesEvent"
                if(this.yesEvent) {
                    this.yesEvent()
                }

                // hide the modal
                this.noHandler()
            }
        }
    }
</script>
